<template>
  <v-dialog
    :value="isShowing"
    title="Add a new crypto rate"
    width="600px"
    @close="$emit('update:isShowing', false)"
  >
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Verify Transaction</span>
        <span> {{ transaction.id }}</span>
        <v-btn text icon dark @click="$emit('update:isShowing', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <custom-form :action="action" method="put" @submitted="$emit('verified', $event)">
          <custom-input
            name="rate"
            :label="label"
            hint="Applied Rate"
            persistent-hint
            :placeholder="placeholder"
          />
          <custom-button color="primary" large raised tile block>
            Verify Transaction
          </custom-button>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isShowing: {
      required: true,
      type: Boolean,
    },
    transaction: {
      required: true,
      type: Object,
    },
  },
  computed: {
    label() {
      const title = `Applied ${this.objectValueFromPath(
        this.transaction,
        "reference_currency.short_name",
      )} to ${this.objectValueFromPath(this.transaction, "crypto_currency.short_name")} Rate`;

      return this.titleCase(title);
    },
    action() {
      return `api/v1/cryptoTransactions/${this.transaction.id}/verify`;
    },
    placeholder() {
      return `1 ${this.titleCase(
        this.objectValueFromPath(this.transaction, "reference_currency.short_name"),
      )} = ?_____  ${this.objectValueFromPath(this.transaction, "crypto_currency.short_name")} `;
    },
  },
};
</script>
